import React, { useEffect, useState } from 'react';
import { pageKey } from '../../../../helpers/path';
import { useLang } from '../../../../hooks/use-lang';
import { useQueryParams } from '../../../../hooks/use-query-params';
import { TableFilter } from '../table-filter';
import s from './table-filter-input.module.css';
import { Input } from '../../../../components/input/input';

interface Props {
  name: string;
  suggestOptions?: string[];
}

export const  TableFilterInput = (props: Props) => {
  const { name, suggestOptions } = props;

  const { addQueryParams, getQueryParams } = useQueryParams();
  const [search, setSearch] = useState('');
  const { t } = useLang();

  const [initSuggests, setInitSuggests] = useState(
    suggestOptions?.length ? suggestOptions : undefined,
  );

  useEffect(() => {
    if (initSuggests?.length) return;

    setInitSuggests(suggestOptions);
  }, [suggestOptions]);

  const params = getQueryParams();
  const paramName = params[name] || '';

  useEffect(() => {
    setSearch(paramName);
  }, [paramName]);

  // const suggestions = useMemo(() => {
  //   const filtered = search
  //     ? initSuggests?.filter((item) => filterByName(item, search))
  //     : initSuggests;

  //   return Array.from(new Set(filtered).values());
  // }, [search, initSuggests]);

  const onSearch = (value: React.ChangeEvent<HTMLInputElement>) =>
    setSearch(value.currentTarget.value);

  const handleOk = () => {
    addQueryParams({ [name]: search.trim(), [pageKey]: '1' });
  };

  const handleReset = () => {
    addQueryParams({ [name]: undefined, [pageKey]: '1' });
    setSearch('');
  };

  return (
    <TableFilter
      className={s.feature}
      onReset={handleReset}
      onSubmit={handleOk}
      name={name as string}
    >
      <Input value={search} onChange={onSearch} placeholder={t('Поиск')} autoFocus />
      {/* {!!suggestions?.length && (
        <ul className={s.list}>
          {suggestions?.map((item, index) => {
            return (
              <li
                key={item + index}
                tabIndex={0}
                className={s.item}
                onClick={() => setSearch(item)}
              >
                <span>{item}</span>
              </li>
            );
          })}
        </ul>
      )} */}
    </TableFilter>
  );
};
